import {
  Box,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tab,
} from "@chakra-ui/react";
import React from "react";
import PersonalInfo from "./PersonalInfo";
import ContactInfo from "./ContactInfo";
import NextOfKin from "./NextOfKin";
import FamilyDetails from "./FamilyDetails";
import AcademicDetails from "./AcademicDetails";
import { Link } from "react-router-dom";

const PersonalRecord = () => {

  return (

    <div className="min-h-screen bg-gray-50 p-2 md:p-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-wrap items-center gap-1 mb-6 text-sm">
          <span className="text-gray-500">Manage Staffs /</span>
          <Link to="/settings/user-list" className="text-gray-500 hover:text-gray-700">
            Manage Users /
          </Link>
          <span className="text-gray-900 font-medium">View User</span>
        </div>
        
        <div className="bg-white rounded-lg shadow-sm">
          <Tabs position='relative' variant='unstyled'>
            <div className="border-b border-gray-200  overflow-x-auto md:px-4">
              <TabList className="flex  gap-2 md:gap-0 -mb-px">
                <Tab
                  fontSize={{ base: "sm", md: "md" }}
                  fontWeight={"medium"}
                  px={{ base: 2, md: 4 }}
                  py={3}
                  color='gray.600'
                  _selected={{ 
                    color: '#984779', 
                    fontWeight: 'semibold',
                    borderBottomColor: '#984779'
                  }}
                  _hover={{ color: '#984779' }}
                  borderBottom="2px solid transparent"
                  transition="all 0.2s"
                  whiteSpace="nowrap"
                >
                  Personal Info
                </Tab>
                <Tab
                  fontSize={{ base: "sm", md: "md" }}
                  fontWeight={"medium"}
                  px={{ base: 2, md: 4 }}
                  py={3}
                  color='gray.600'
                  _selected={{ 
                    color: '#984779', 
                    fontWeight: 'semibold',
                    borderBottomColor: '#984779'
                  }}
                  _hover={{ color: '#984779' }}
                  borderBottom="2px solid transparent"
                  transition="all 0.2s"
                  whiteSpace="nowrap"
                >
                  Contact Info
                </Tab>
                <Tab
                  fontSize={{ base: "sm", md: "md" }}
                  fontWeight={"medium"}
                  px={{ base: 2, md: 4 }}
                  py={3}
                  color='gray.600'
                  _selected={{ 
                    color: '#984779', 
                    fontWeight: 'semibold',
                    borderBottomColor: '#984779'
                  }}
                  _hover={{ color: '#984779' }}
                  borderBottom="2px solid transparent"
                  transition="all 0.2s"
                  whiteSpace="nowrap"
                >
                  Next of Kin
                </Tab>
                <Tab
                  fontSize={{ base: "sm", md: "md" }}
                  fontWeight={"medium"}
                  px={{ base: 2, md: 4 }}
                  py={3}
                  color='gray.600'
                  _selected={{ 
                    color: '#984779', 
                    fontWeight: 'semibold',
                    borderBottomColor: '#984779'
                  }}
                  _hover={{ color: '#984779' }}
                  borderBottom="2px solid transparent"
                  transition="all 0.2s"
                  whiteSpace="nowrap"
                >
                  Family Details
                </Tab>
                <Tab
                  fontSize={{ base: "sm", md: "md" }}
                  fontWeight={"medium"}
                  px={{ base: 2, md: 4 }}
                  py={3}
                  color='gray.600'
                  _selected={{ 
                    color: '#984779', 
                    fontWeight: 'semibold',
                    borderBottomColor: '#984779'
                  }}
                  _hover={{ color: '#984779' }}
                  borderBottom="2px solid transparent"
                  transition="all 0.2s"
                  whiteSpace="nowrap"
                >
                  Academic Details
                </Tab>
              </TabList>
            </div>
            <TabPanels>
              <TabPanel p={0}>
                <PersonalInfo />
              </TabPanel>
              <TabPanel p={0}>
                <ContactInfo />
              </TabPanel>
              <TabPanel p={0}>
                <NextOfKin />
              </TabPanel>
              <TabPanel p={0}>
                <FamilyDetails />
              </TabPanel>
              <TabPanel p={0}>
                <AcademicDetails />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </div>
      </div>
    </div>

  );
  
};

export default PersonalRecord;
